import { KeyboardAwareScrollView as _KeyboardAwareScrollView } from "react-native-keyboard-controller"

export const KeyboardAwareScrollView = _KeyboardAwareScrollView
